export default __webpack_public_path__ + "static/media/coin-full.f9cfbf6b.png";